import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Form = ({ children, onSubmit }) => /* @__PURE__ */ React.createElement(
  "form",
  {
    autoComplete: "off",
    noValidate: true,
    className: cx(styles.form),
    onSubmit
  },
  children
);
Form.displayName = "Forms.SelfExclusion.Form";

export { Form };
//# sourceMappingURL=index.js.map
